import React from "react";
import { getFormattedNumber } from "../utils/textUtils";

const BelowOrderLimitReport = ({ resPacket }) => {
  return resPacket?.length > 0 ? (
    <div className="customTable" id="scroll">
      <table className="customTable">
        <thead className="fixed-thead">
          <tr>
            <td className="text-right">SNO.</td>
            <td className="text-left">ITEM</td>
            <td className="text-left">CATEGORY</td>
            <td className="text-right">REORDER POINT</td>
          </tr>
        </thead>
        <tbody className="body-scroll-custom">
          {resPacket.map((a, i) => (
            <tr key={i}>
              <td className="text-right">{i + 1}</td>
              <td className="text-left">{a.itemTitle}</td>
              <td className="text-left">{a.categoryTitle || ""}</td>
              <td className="text-right">{a.reorderPoint ? getFormattedNumber(a.reorderPoint) : ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <>No Record found</>
  );
};

export default BelowOrderLimitReport;
